<script setup>
import { computed } from 'vue'
import { getI18n } from '@/plugins/i18n'
import { ROI_COMPARISON_COLORS, useRoiComparisonFormat } from '@/composables/roi-comparison'

import RoiComparisonBar from '@/components/roi/RoiComparisonBar.vue'

const props = defineProps({
  comparison: {
    type: Object,
    required: true,
  },
  metric: {
    type: Object,
    required: true,
  },
  row: {
    type: Object,
    required: true,
  },
  best: {
    type: Set,
    required: true,
  },
  text: {
    type: String,
    required: true,
  },
  compact: {
    type: Boolean,
    default: false,
  },
})

const i18n = getI18n()
const { isNumeric, barWidth, barTone, valueClass, cellDelta, deltaClass, formatDelta } = useRoiComparisonFormat()

const delta = computed(() => cellDelta(props.comparison, props.metric, props.row))
</script>

<template>
  <div class="roi-value">
    <div class="row items-center no-wrap q-gutter-x-xs">
      <span :class="valueClass(metric, row, best)">{{ text }}</span>
      <q-icon
        v-if="best.has(row.id) && !compact"
        name="mdi-star"
        :color="ROI_COMPARISON_COLORS.BEST"
        size="xs"
      >
        <q-tooltip>{{ i18n.t('roiCompare.best') }}</q-tooltip>
      </q-icon>
    </div>
    <roi-comparison-bar v-if="isNumeric(metric) && !compact" :width="barWidth(metric, row.values, comparison.rows)" :tone="barTone(metric, row, best)" />
    <div v-if="delta !== null" class="text-caption row items-center no-wrap" :class="deltaClass(metric, delta)">
      <q-icon v-if="delta && !compact" :name="delta > 0 ? 'mdi-menu-up' : 'mdi-menu-down'" size="xs" />
      {{ formatDelta(delta) }}
    </div>
  </div>
</template>

<style scoped>
.roi-value {
  min-width: 0;
}
</style>
